import React, { useState } from "react";

const OptionInput = ({ options, setOptions }) => {
  const [input, setInput] = useState("");

  const addOption = () => {
    const trimmed = input.trim();
    if (!trimmed) return;
    if (options.includes(trimmed)) {
      alert("Duplicate option!");
      return;
    }
    setOptions([...options, trimmed]);
    setInput("");
  };

  const removeOption = (opt) => {
    setOptions(options.filter((o) => o !== opt));
  };

  const handleKeyDown = (e) => {
    if (e.key === "Enter" || e.key === ",") {
      e.preventDefault();
      addOption();
    }
  };

  return (
    <div>
      <div className="flex flex-wrap gap-2 mb-2">
        {options.map((opt, idx) => (
          <div
            key={idx}
            className="bg-blue-200 text-blue-800 px-2 py-1 rounded flex items-center"
          >
            {opt}
            <button
              onClick={() => removeOption(opt)}
              className="ml-1 text-red-500 font-bold"
            >
              ×
            </button>
          </div>
        ))}
      </div>
      <input
        type="text"
        value={input}
        onChange={(e) => setInput(e.target.value)}
        onKeyDown={handleKeyDown}
        placeholder="Type option and press Enter or Comma"
        className="border p-1 w-full"
      />
    </div>
  );
};

const CanvasField = ({ field, updateField, saveField, removeField }) => {
  if (!field) return null;

  const renderFieldInput = () => {
    switch (field.type) {
      case "text":
        return <input type="text" className="border p-1 w-full" min={field.min} max={field.max} required />;
      case "textbox":
        return <textarea className="border p-1 w-full" minLength={field.min} maxLength={field.max} required />;
      case "number":
        return <input type="number" className="border p-1 w-full" min={field.min} max={field.max} required />;
      case "range":
        return <input type="range" className="border w-full" min={field.min} max={field.max} required />;
      case "email":
        return <input type="email" className="border p-1 w-full" required />;
      case "tel":
        return <input type="tel" className="border p-1 w-full" required />;
      case "url":
        return <input type="url" className="border p-1 w-full" required />;
      case "search":
        return <input type="search" className="border p-1 w-full" required />;
      case "datetime-local":
        return <input type="datetime-local" className="border p-1 w-full" required />;
      case "date":
        return <input type="date" className="border p-1 w-full" required />;
      case "time":
        return <input type="time" className="border p-1 w-full" required />;
      case "month":
        return <input type="month" className="border p-1 w-full" required />;
      case "week":
        return <input type="week" className="border p-1 w-full" required />;
      case "file":
        return <input type="file" className="border p-1 w-full" required />;
      case "image":
        return <input type="file" accept="image/*" className="border p-1 w-full" required />;
      case "dropdown":
      case "checkbox":
      case "radio":
        return (
          <OptionInput
            options={field.options ? field.options.split(",") : []}
            setOptions={(opts) => updateField("options", opts.join(","))}
          />
        );
      default:
        return null;
    }
  };

  const showMinMax = ["text", "textbox", "number", "range"].includes(field.type);

  return (
    <div className="p-3 border rounded bg-white shadow-sm">
      <div className="flex gap-2 mb-2">
        <input
          type="text"
          placeholder="Field Name"
          className="border p-1 flex-1"
          value={field.fieldName}
          onChange={(e) => updateField("fieldName", e.target.value)}
        />
        <input
          type="text"
          placeholder="Field Label"
          className="border p-1 flex-1"
          value={field.fieldLabel}
          onChange={(e) => updateField("fieldLabel", e.target.value)}
        />
      </div>

      {showMinMax && (
        <div className="flex gap-2 mb-2">
          <input
            type="number"
            placeholder="Min"
            className="border p-1 flex-1"
            value={field.min}
            onChange={(e) => updateField("min", e.target.value)}
          />
          <input
            type="number"
            placeholder="Max"
            className="border p-1 flex-1"
            value={field.max}
            onChange={(e) => updateField("max", e.target.value)}
          />
        </div>
      )}

      {renderFieldInput()}

      <label className="flex items-center gap-2 mb-2">
        <input
          type="checkbox"
          checked={field.mandatory}
          onChange={(e) => updateField("mandatory", e.target.checked)}
        />
        Mandatory
      </label>

      <div className="flex gap-2">
        <button
          onClick={() => saveField(field.tempId)}
          className="bg-green-500 text-white px-2 py-1 rounded"
        >
          Save
        </button>
        <button
          onClick={removeField}
          className="bg-red-500 text-white px-2 py-1 rounded"
        >
          Remove
        </button>
      </div>
    </div>
  );
};

export default CanvasField;
